<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";
    import {itemRarity} from '../../constants';

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_(
            'CommanderRankPoint' + itemRarity[gameItem.rarity] + 'Title',
        );
        itemDetails.description = $_(
            'CommanderRankPoint' + itemRarity[gameItem.rarity] + 'Description',
            {values: {AMOUNT: gameItem.amount}},
        );
        itemDetails.amount = item.amount;
        itemDetails.icon = 'commander_rank_point_' + itemRarity[gameItem.rarity];
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
